export default interface StornoOptions {
  // ha stornozáskor történik még más egyéb ami a usertől függ, akkor azt ide kell felvenni, és a backenden kezelni
  shipDate: Date | string | null;
  // a felhasználó a sztornózáskor az elektronikus kiküldést választotta-e
  sendElectronically: boolean;
}

export const stornoOptionsDefaultProps: StornoOptions = {
  shipDate: null,
  sendElectronically: false,
};
